module.exports = __webpack_public_path__ + "static/media/success.444a6802.png";